// extracted by mini-css-extract-plugin
module.exports = {"tippedInfo":"TippedItem_tippedInfo__gqC0F","tippedIcon":"TippedItem_tippedIcon__uxTC_","deletedUser":"TippedItem_deletedUser__PsEZN"};